module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "fm"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户名",
      "icon": "x-user"
    },
    model: {
      value: (_vm.userinfo.name),
      callback: function($$v) {
        _vm.userinfo.name = $$v
      },
      expression: "userinfo.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入密码",
      "icon": "x-lock",
      "type": "password"
    },
    model: {
      value: (_vm.userinfo.pwd),
      callback: function($$v) {
        _vm.userinfo.pwd = $$v
      },
      expression: "userinfo.pwd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登    录")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-68b20f8e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/xelement/login.vue
// module id = 224
// module chunks = 2